
import {applyMiddleware, createStore} from 'redux';
import {persistStore, persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage'
import thunk from 'redux-thunk';

import appReducer from '../reducers';
import * as authActionTypes from '../actions/types';

import autoMergeLevel1 from 'redux-persist/lib/stateReconciler/autoMergeLevel1';

// const logger = createLogger({
//     timestamps: true,
//     duration: true,
// })

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
  stateReconciler: autoMergeLevel1,
};

const rootReducer = (state, action) => {
  if (action.type === authActionTypes.LOGOUT) {
    state = {
      ...state,
      auth: {
        user: null,
      },
    };
  }

  return appReducer(state, action);
};

const pReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(pReducer, applyMiddleware(thunk));
export const persistor = persistStore(store);